export class CampaignFiltersMenu {
  key: string | number;
  label: string | number;
  isArray?: boolean;
  isMultiSelect?: boolean;
  children?: Array<CampaignFiltersMenu>;
  childrenGroups?: Array<CampaignFiltersMenu>;
}
